import ticketSingle from "../../assets/png/ticket_single.png";
import AccountNumber from "../../components/LoginModal/pages/AccountNumber";
import VerificationCode from "../../components/LoginModal/pages/VerificationCode";
import SetInformation from "../../components/LoginModal/pages/SetInformation";
import ChooseTeam from "../../components/LoginModal/pages/ChooseTeam";
import { useState } from "react";

const LoginModal = ({ toggleModal, setAvatar }) => {
  const [phoneValue, setphoneValue] = useState();
  const [nationText, setnationText] = useState();
  const elArray = [
    {
      name: "AccountNumber",
      fn: () => {
        return (
          <AccountNumber
            className=""
            setAvatar={setAvatar}
            toInformation={() => {
              setShow("SetInformation");
            }}
            toVerificationCode={(phoneValue, nationText) => {
              setShow("VerificationCode");
              setphoneValue(phoneValue);
              setnationText(nationText);
            }}
          />
        );
      },
    },
    {
      name: "VerificationCode",
      fn: () => {
        return (
          <VerificationCode
            toInformation={() => {
              setShow("SetInformation");
            }}
            setAvatar={setAvatar}
            props={{ phoneValue, nationText }}
            BackAccountNumber={() => {
              setShow("AccountNumber");
            }}
          />
        );
      },
    },
    {
      name: "SetInformation",
      fn: () => {
        return (
          <SetInformation
            toChooseTeam={() => {
              setShow("ChooseTeam");
            }}
          />
        );
      },
    },
    {
      name: "ChooseTeam",
      fn: () => {
        return <ChooseTeam setAvatar={setAvatar} />;
      },
    },
  ];
  const [show, setShow] = useState(elArray[0].name);
  const getPage = () => {
    for (let index = 0; index < elArray.length; index++) {
      const item = elArray[index];
      if (item.name === show) {
        return item.fn();
      }
    }
  };
  return (
    <div className="fixed  z-50 w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[100%] max-h-full bg-[rgba(0, 0, 0, 0.61)] backdrop-blur-[7px] inset-0">
      <div className="relative w-full h-full flex items-center justify-center">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-[10px] shadow w-[317px] h-[417px] m-auto flex flex-col">
          {/* <!-- Modal header --> */}
          <div className="flex rounded-t-[10px] bg-stadeo-bold-green h-[75px]">
            <div className="pl-[51px] w-[155px] pt-[19px] leading-[14px]">
              <p className="font-monumentextended text-[12px] font-bold text-white">
                LOGIN TO PURCHASE TICKETS
              </p>
            </div>
            <div className="ml-[20px] pt-[17px] relative">
              <img
                className="w-[45px] md:w-[55px] absolute top-[15px] left-[6px] z-10"
                src={ticketSingle}
                alt="Ticket Single"
              />
              <img
                className="w-[45px] md:w-[55px] relative z-20"
                src={ticketSingle}
                alt="Ticket Single"
              />
            </div>
            <button
              type="button"
              className="absolute right-[11px] top-[11px] text-white text-sm"
              onClick={setAvatar}
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          {/* <!-- Modal body --> */}
          <div className="w-full  flex-1 flex flex-col">{getPage()}</div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
